module.exports = __webpack_public_path__ + "static/media/cosmetics3.d91cb515.png";